import { setCookie } from '@lhb/cache';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitStata {
  userInfo: any; // 用户信息
  cities: any[]; // 城市列表
  departmentCities: any[]; // 部门所属城市列表
  businessLevel: any[]; // 商圈等级列表
  provinceCityDistrict: any[]; // 省市区
  provincesCities: any[]; // 省市
  citiesWithEN: any[]; // 带有拼音的城市列表
  companyRoles: any[]; // 公司角色
  companyRolesAll: any[]; // 公司角色(包含离职)
   // 专供高德地图的城市数据，数据格式
  // [{name: 城市名称, id: 城市id, provinceName: 所属省份名称, provinceId: 所属省份id, district: [] 区数据}]
  cityForAMap: any[];
}

const initialState: InitStata = {
  userInfo: {},
  cities: [], // 包含城市及其区域
  departmentCities: [],
  businessLevel: [],
  provinceCityDistrict: [], // 省市区
  provincesCities: [], // 省市
  citiesWithEN: [], // 带有拼音的城市列表
  companyRoles: [], // 公司角色
  companyRolesAll: [], // 公司角色(包含离职)
  cityForAMap: [], // 专供高德地图的城市数据，数据格式
};

function refactorCities(data) {
  const cities = data.map((item: any) => {
    return item ? {
      value: item.id,
      label: item.name,
      children: item?.districts?.map(itm => {
        return {
          value: itm.id,
          label: itm.name,
        };
      })
    } : {};
  });
  return cities;
}

const customerSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    UPDATE_USER: (state = initialState, action: PayloadAction<any>) => {
      state.userInfo = action.payload;
      // 用于埋点
      action.payload?.tenantId && setCookie('tenant_id', action.payload?.tenantId);
    },
    changeCities: (state = initialState, action: PayloadAction<any[]>) => {
      state.cities = refactorCities(action.payload);
    },
    changeDepartmentCities: (state = initialState, action: PayloadAction<any[]>) => {
      state.departmentCities = refactorCities(action.payload);
    },
    changeBusinessLevel: (state = initialState, action: PayloadAction<any[]>) => {
      state.businessLevel = action.payload;
    },
    changeProvinceCityDistrict: (state = initialState, action: PayloadAction<any[]>) => {
      const _cityForAMap: any[] = [];
      // 禁选特殊的行政区
      state.provinceCityDistrict = action.payload.map((item: any) => {
        if (['台湾', '香港', '澳门'].some(region => item.name.indexOf(region) !== -1)) {
          item.children?.forEach(city => {
            city.disabled = true;
            city.children?.forEach(district => {
              district.disabled = true;
            });
            // cityForAMap数据组装
            _cityForAMap.push({
              name: city.name,
              id: city.id,
              code: city.code,
              provinceName: item.name,
              provinceId: item.id,
              provinceCode: item.code,
              district: city.children,
              disabled: true,
              pinyin: item.pinyin// 省份的拼音
            });
          });
          return {
            ...item,
            disabled: true
          };
        }
        // cityForAMap数据组装
        item.children?.forEach(city => {
          _cityForAMap.push({
            name: city.name,
            id: city.id,
            code: city.code, // 对应高德数据中城市的adcode
            provinceName: item.name,
            provinceId: item.id,
            provinceCode: item.code, // 对应高德数据中省份的adcode
            district: city.children,
            pinyin: item.pinyin// 省份的拼音
          });
        });
        return item;
      });
      state.cityForAMap = _cityForAMap;
    },
    changeProvincesCities: (state = initialState, action: PayloadAction<any[]>) => {
      state.provincesCities = action.payload.map((item: any) => {
        if (['台湾', '香港', '澳门'].some(region => item.name.indexOf(region) !== -1)) {
          item.children?.forEach(city => {
            city.disabled = true;
          });
          return {
            ...item,
            disabled: true
          };
        }
        return item;
      });
    },
    changeCompanyRoles: (state = initialState, action: PayloadAction<any[]>) => {
      state.companyRoles = action.payload;
    },
    changeCompanyRolesAll: (state = initialState, action: PayloadAction<any[]>) => {
      state.companyRolesAll = action.payload;
    },
    changeCitiesWithEN: (
      state = initialState,
      action: PayloadAction<any[]>,
    ) => {
      state.citiesWithEN = action.payload.map((item: any) => {
        if (['台北', '香港', '澳门'].some((region) => item.name.indexOf(region) !== -1)) {
          item.children?.forEach(city => {
            city.disabled = true;
          });
          return {
            ...item,
            disabled: true
          };
        }
        return item;
      });
    },
  },
});

// 导出action
export const { UPDATE_USER, changeCities, changeDepartmentCities, changeBusinessLevel, changeProvinceCityDistrict, changeProvincesCities, changeCompanyRoles, changeCompanyRolesAll, changeCitiesWithEN } = customerSlice.actions;

export default customerSlice.reducer;
